import React from 'react'

export const ChannelFilterContext = React.createContext()

export const channelFilterDefaultState = {
  selectorType: 'all',   // 'all', 'byFeatures', or, 'byCodes'
  byFeatures: {
    // sampling rate
    _20sps: false,
    _100sps: false,
    // station type
    surface: false,
    borehole: false,
    // sensor type
    accelerometer: false,
    broadband: false,
    shortperiod: false,
  },
  byCodes: [],
}


const compareCodes = (codes1, codes2) => {
  if (codes1.length !== codes2.length) {
    return false
  }
  if (codes1.some((code, index) => code !== codes2[index])) {
    return false
  }
  return true
}

export const channelFilterReducer = (state, action) => {
  console.log('channelFilterReducer: ', action)
  switch (action.type) {
    case 'SET_SELECTOR_TYPE': {
      const {value} = action
      if (value !== state.selectorType) {
        return {...state, selectorType: value}
      }
      return state
    }
    case 'SET_FILTER_VALUE': {
      const {category, key, value: rawValue} = action
      const value = (rawValue && rawValue.trim) ? rawValue.trim() : rawValue
      if (category && state[category]) {
        if (value !== state[category][key]) {
          return {...state, [category]: {...state[category], [key]: value}}
        }
      }
      return state
    }
    case 'SET_FILTER_CODES': {
      const value = action.value.sort()
      if (!compareCodes(value, state.byCodes)) {
        return {...state, byCodes: [...value]}
      }
      return state
    }
    default:
      return state
  }
}


const matchChannelCode = (pattern, channelCode) => {
  // length of pattern and length of channelCode must be equal
  for (let i = 0; i < pattern.length; ++i) {
    if (pattern[i] !== '?' && pattern[i] !== channelCode[i]) {
      return false
    }
  }
  return true
}

export const selectChannels = (stations, state) => {
  const selectedChannels = []
  console.log(stations)
  console.log(state)

  if (state.selectorType === 'all' || Object.values(state.byFeatures).every(value => value) || state.byCodes.includes('???')) {
    const channelMap = {}
    stations.forEach(station => {
      station.channels.forEach(channel => {
        const streamId = `${station.network_code}.${station.code}.${channel.location_code}.${channel.code}` 
        if (!channelMap[streamId]) {
          selectedChannels.push({
            streamId,
            network: station.network_code,
            station: station.code,
            location: channel.location_code,
            channel: channel.code,
            stationName: station.name
          })
          channelMap[streamId] = true
        }
      })
    })
  } else if (state.selectorType === 'byFeatures') {
    const {byFeatures} = state
    const channelMap = {}
    stations.forEach(station => {
      station.channels.forEach(channel => {
        if (((byFeatures._20sps && byFeatures._100sps)
            || (byFeatures._20sps && channel.sample_rate === 20.)
            || (byFeatures._100sps && channel.sample_rate === 100.)) 
          &&
            ((byFeatures.surface && byFeatures.borehole)
            || (byFeatures.surface && channel.depth === 0.)
            || (byFeatures.borehole && channel.depth > 0.))
          &&
            ((byFeatures.accelerometer && byFeatures.broadband && byFeatures.shortperiod)
            || (byFeatures.accelerometer && channel.sensor_type === 'accelerometer')
            || (byFeatures.broadband && channel.sensor_type === 'broadband')
            || (byFeatures.shortperiod && channel.sensor_type === 'shortperiod'))) {
          const streamId = `${station.network_code}.${station.code}.${channel.location_code}.${channel.code}`
          if (!channelMap[streamId]) {
            selectedChannels.push({
              streamId,
              network: station.network_code,
              station: station.code,
              location: channel.location_code,
              channel: channel.code,
              stationName: station.name
            })
            channelMap[streamId] = true
          }
        }
      })
    })
  } else if (state.selectorType === 'byCodes') {
    if (state.byCodes.length === 0) {
      throw new Error('noCustomChannelError')
    }
    if (state.byCodes.some(code => code.length !== 3)) {
      throw new Error('channelCodeMustBe3Error')
    }
    const channelMap = {}
    stations.forEach(station => {
      station.channels.forEach(channel => {
        if (state.byCodes.some(customChannel => matchChannelCode(customChannel, channel.code))) {
          const streamId = `${station.network_code}.${station.code}.${channel.location_code}.${channel.code}`
          if (!channelMap[streamId]) {
            selectedChannels.push({
              streamId,
              network: station.network_code,
              station: station.code,
              location: channel.location_code,
              channel: channel.code,
              stationName: station.name
            })
            channelMap[streamId] = true
          }
        }
      })
    })
  }
  // return data type: [{streamId, network, station, location, channel, stationName}, ...]
  return selectedChannels
}


export const selectOneChannelPerSensor = (stations, state) => {
  const selectedChannels = {}
  const selectedAllChannels = selectChannels(stations, state)

  if (selectedAllChannels.length > 0) {
    const selectedChannelMap = {}
    selectedAllChannels.forEach(channel => {
      // console.log(channel)
      // const streamId = `${channel.network}.${channel.station}.${channel.location}.${channel.channel}`
      const streamId = channel.streamId
      const sensorAndSamplingRateId = streamId.slice(0, -1)
      if (!(sensorAndSamplingRateId in selectedChannelMap)) {
        selectedChannelMap[sensorAndSamplingRateId] = streamId
        selectedChannels[streamId] = channel
      }
    })
  }
  // return selectedChannels
  
  // return data type: [{streamId, network, station, location, channel, stationName}, ...]
  return Object.values(selectedChannels)
}